export const content = {
  navigation: [
    { 
      name: 'Forside', 
      href: '/'
    },
    { 
      name: 'Om Lene', 
      href: '/om-lene'
    },
    { 
      name: 'Kørekort', 
      href: '#korekort'
    },
    { 
      name: 'Galleri', 
      href: '#galleri'
    },
    { 
      name: 'FAQ', 
      href: '#faq'
    },
    { 
      name: 'Kontakt', 
      href: '/kontakt'
    },
  ],
  hero: {
    title: 'VELKOMMEN TIL LENES KØRESKOLE I AABENRAA',
    subtitle: 'Er du klar til at sætte kursen mod friheden på vejen?',
    description: 'Med mere end 25 års ekspertise bag mig har jeg guidet talrige elever mod målstregen, så lad mig hjælpe dig med at føle dig selvsikker og tryg, når du træder ud i trafikken på egen hånd. Det handler dog ikke kun om at mestre bilen – det handler også om at mestre dine nerver. Jeg er her for at tackle enhver form for bekymring eller nervøsitet, du måtte have under forløbet.',
    cta: 'Tilmeld dig nu',
    image: '/imgi_2_Lene-Hero-img-e1711055194243.jpg',
  },
  about: {
    title: 'Mit arbejde gør dig sikker og tryg i trafikken',
    subtitle: 'Ansigtet bag din succes',
    description: `Mit navn er Lene Jauert, jeg har mere end 25 års erfaring som kørelærer og har min køreskole i Aabenraa – faktisk den eneste kvindelige kørelærer her. Jeg har derudover taget uddannelser inden for kommunikation, coaching og angstregulering, som har givet mig en masse værktøjer til at tackle mere end blot den praktiske del af kørekortet.

Mine uddannelser og erfaring er medvirkende til, at jeg altid kan hjælpe dig til at træffe de rigtige beslutninger i trafikken. Samtidig kan du føle dig tryg og sikker, når vi sammen gør dig klar til at få kørekortet i trygge rammer.

Jeg har stor erfaring og succes med den naturlige nervøsitet omkring køreprøven. Gennem kommunikation i øjenhøjde og indsigt i den enkelte elev har jeg hjulpet mange til et kørekort og samtidig skabt en god oplevelse omkring det. Dette gælder for alle mine elever, samt elever jeg overtager fra andre køreskoler.`,
    highlight: 'Med mere end 25 års erfaring',
    stats: [
      { label: 'Års erfaring', value: '25+' },
      { label: 'Beståelsesrate', value: 'Høj' },
      { label: 'Lokation', value: 'Aabenraa' },
    ],
    image: '/imgi_44_LJJJ-1-e1711065082405.jpg'
  },
  services: [
    {
      title: 'Personbil (Kategori B)',
      description: 'Komplet forløb til personbil i trygge rammer. Jeg tager det i dit tempo.',
      image: '/492485769_1230766705715062_1632248222522071052_n.jpg',
    },
    {
      title: 'Særlig køreundervisning',
      description: 'Har du mistet kørekortet eller fået kørselsforbud? Jeg hjælper dig tilbage på vejen.',
      image: '/Kundebilleder/imgi_17_Forside-faerdig-2.jpg',
    },
    {
      title: 'Teoriundervisning',
      description: 'Lær teorien i mit hyggelige lokale i Aabenraa. Fokus på forståelse, ikke bare udenadslære.',
      image: '/Kundebilleder/imgi_14_Forside-faerdig-6.jpg',
    },
  ],
  faq: [
    {
      question: 'Hvornår må jeg begynde på kørekort?',
      answer: 'Undervisningen må påbegyndes 3 måneder før du fylder 17 år. Du kan tidligst aflægge teoriprøven 1 måned før du fylder 17 år. Den praktiske prøve må tidligst aflægges den dag du fylder 17 år. Denne afvikles i Aabenraa.',
    },
    {
      question: 'Hvornår skal man have særlig køreundervisning?',
      answer: 'Hvis du er førstegangserhverver, er dit kørekort på prøve. Det vil sige, du mister kørekortet, hvis du inden for de første 3 år efter du har erhvervet kørekortet første gang begår alvorlige fejl. Prøvetiden gælder kun for den første kategori, du tager kørekort til.',
    },
    {
      question: 'Hvor lang tid tager det at få kørekort?',
      answer: 'Det er meget individuelt, hvor længe det tager, men et normalt forløb for at opnå kørekort tager typisk mellem 2,5 og 3,5 måneder. Vi er i og omkring Aabenraa.',
    },
    {
      question: 'Hvad er manøvrebane?',
      answer: 'Det er der, hvor du starter din praktiske undervisning. Der er normalt 3 elever ad gangen på en manøvrebane. Det varer normalt 3 timer. En manøvrebane bliver også kaldt en kravlegård. Du skal lære at kravle før du kan gå. Jeg bruger køreteknisk anlæg i Rødekro.',
    },
    {
      question: 'Hvordan foregår teoriprøven?',
      answer: 'Du får vist 25 billeder og til hvert billede er der fra 2 – 4 svarmuligheder. For at bestå teoriprøven skal du have 20 rigtige. Teoriprøven foregår hos færdselsstyrelsen på adressen: Sankt Nicolai Gade 5, 6200 Aabenraa.',
    },
    {
      question: 'Førstehjælpskursus',
      answer: 'Når du tager kørekort, skal du gennemføre et 8 timers kursus i færdselsrelateret førstehjælp. Jeg afholder førstehjælpskursus i mit teorilokale i Aabenraa.',
    },
  ],
  extra: {
    theoryTest: {
      title: 'Test dig selv i en teoriprøve',
      link: 'https://xn--teoriklar-l3a.dk/teoriproeve/gratis-teoriproeve-1',
      buttonText: 'Tag testen her'
    },
    examCards: {
      title: 'Læs om de 6 opgavekort til prøven',
      link: 'https://lenejauert.dk/wp-content/uploads/2024/03/6-opgavekort-til-proeven.pdf',
      buttonText: 'Læs om dem her'
    },
    vision: 'Vi hjælper hinanden med at forstå og lære hvordan trafikken fungerer, så du kan blive en sikker, hensynsfuld og agtpågivende bilist.'
  },
  testimonials: [
    {
      name: 'Amina Otour',
      text: 'Lene er et rigtig dejligt menneske at være hos. Hun giver dig altid gode råd og er super god til at holde nervøsiteten nede når det kan være svært. Med Lene er det et trygt sted. Der er ingen dumme spørgsmål og man kan altid få en god snak. 🥰',
      date: 'April 2026',
      rating: 5,
    },
    {
      name: 'Liva Mauter Andersen',
      text: 'Lene er en fantastisk kørelærer og person! Hun har været en kæmpe støtte og hjælp igennem hele forløbet, også i forhold til min angst. Udover kørekortet kan jeg også takke hende for øget selvtillid og beroligende ord, som jeg stadig minder mig selv om i ængstelige situationer. Jeg kan kun anbefale hende på det kraftigste!',
      date: 'Februar 2026',
      rating: 5,
    },
    {
      name: 'Oliver Rosted',
      text: 'Jeg har haft en rigtig god oplevelse hos Lenes køreskole. Fra start til slut har der været en tryg og behagelig stemning, og jeg har følt mig godt støttet hele vejen igennem. Kørelæreren var tålmodig, rolig og god til at forklare – også når noget var svært eller skulle gentages. Jeg følte mig aldrig presset, men derimod motiveret og mere sikker for hver køretime. Det har betyder meget for mig at føle mig tryg, og det har denne køreskole virkelig formået at skabe. Kan varmt anbefales til andre, der ønsker en professionel og tryg vej til kørekortet.',
      date: 'Februar 2026',
      rating: 5,
    },
    {
      name: 'Lærke Juhl Hansen',
      text: 'Jeg valgte at skifte til Lenes Køreskole efter et tidligere forløb, hvor der ikke blev taget ordentligt hånd om min angst og mine mange spørgsmål. For mig var det vigtigt at føle mig tryg, forstået og mødt i mit tempo – og det fandt jeg hos Lene. Lene er utrolig omsorgsfuld, tålmodig og nærværende. Hun skaber en rolig og tryg stemning, hvor der er plads til både følelser, usikkerhed og læring. Jeg følte mig set som menneske – ikke bare som elev – og det gjorde en enorm forskel for mig. Hos Lene handlede det ikke kun om at bestå køreprøven, men om at opbygge selvtillid og tryghed bag rattet. Jeg er meget taknemmelig for mit forløb og kan kun give mine varmeste anbefalinger ❤️🚗',
      date: 'Februar 2026',
      rating: 5,
    },
    {
      name: 'Isabella Lind Pedersen',
      text: 'Lene er en sindssyg dygtig kørelærer som er god til at lære fra sig. Hun er utrolig imødekommende også selvom du kommer og har en frygt for at køre bil. Jeg kan virkelig anbefale Lene som kørelærer🥰 hun er bare så skønt et menneske, som du ikke kommer til at fortryde, at du har valgt!',
      date: 'Marts 2026',
      rating: 5,
    },
    {
      name: 'Frieda Andersen',
      text: 'Jeg kan kun give en kæmpe anbefaling til Lenes køreskole. Min kørelærer var voldsomt sød, tålmodig og utrolig støttende, især når det kom til nerver og nervøsitet op til køreprøven. Hun hjalp med at skabe en rolig stemning, som gjorde en kæmpe forskel for min tillid til mig selv bag rattet. Hvis du leder efter en kørelærer, der virkelig går op i sine elever og deres evner så er dette stedet.🌟',
      date: 'Februar 2026',
      rating: 5,
    },
    {
      name: 'Christoffer Meldgaard',
      text: 'Jeg tog mit kørekort hos Lenes Køreskole, og det kan klart anbefales! Undervisningen var professionel, rolig og rigtig godt tilpasset, så man føler sig tryg hele vejen igennem. Lene er tålmodig, dygtig til at forklare tingene og skaber en god rigtigt god stemning både i teorilokalet og i bilen. Det gjorde hele forløbet super godt og hyggeligt. Stor anbefaling herfra!',
      date: 'Februar 2026',
      rating: 5,
    },
    {
      name: 'Freja Hye',
      text: 'Jeg vil klart anbefale Lene som kørelære, da hun har været en kæmpe hjælp til både hurtig læring og hvis man er utryg i trafikken. Hun er sød og dygtig. Jeg er så glad for at jeg valgte hende da jeg skulle tage mit kørekort!♥️',
      date: 'Februar 2026',
      rating: 5,
    },
    {
      name: 'Lucie Hempel',
      text: 'Lene er en super sød, venlig og hjælpsom kørelærer, hun ved lige hvad hun skal gøre når du føler dig nervøs, utryg i trafikken, bange eller stresset, hun tager alt med ro og får dig super godt igennem køreskolen. Hun har forberedt mig mega godt til både teoriprøven og den praktiske prøve, jeg var slet ikke nervøs for det mere. Derudover er Lene meget nem at snakke med, ligemeget om det har noget at gøre med køreskolen eller ej. Jeg har følt mig virkelig tryg i trafikken i den tid jeg har været hos dig. Stor anbefaling!!!🤗',
      date: 'Februar 2026',
      rating: 5,
    },
    {
      name: 'Mathilde Uldall Mætzke',
      text: 'Jeg synes det er en rigtig god oplevelse ved Lenes Jauert’s køreskole, det går både hurtigt med kørekortet og så er Lene rigtig god til at hjælpe til hvis man har svært ved noget. Lene går også meget op i at man skal forstå bilens funktioner, skilte og regler på vejene, hvilket er rigtig godt så man skal ikke være bange for at spørge om noget to gange!',
      date: 'Februar 2026',
      rating: 5,
    },
    {
      name: 'Lærke Hald',
      text: 'Jeg tog mit kørekort ved Lene sidste efterår, hun er rigtig behagelig at køre med. Hun hjælper en hvis man har det svært, og generelt en man er tryg ved at køre med. gode køretimer og god faglig teoritimer - og altid lækkert med lidt kage til teoritimerne. Anbefaling herfra!🥰',
      date: 'Februar 2026',
      rating: 5,
    },
    {
      name: 'Emma Hinrichs',
      text: 'Jeg kan kun give Lene de bedste anbefalinger. Hun er utrolig sød, rolig og virkelig god til at forklare tingene på en måde, der giver mening. Jeg var meget nervøs, men hun var enormt tålmodig og støttende, og hun hjalp mig med at få mere selvtillid bag rattet. Man føler sig tryg i bilen med hende, og hun tager sig virkelig tid til sine elever. En fantastisk kørelærer!',
      date: 'Februar 2026',
      rating: 5,
    },
    {
      name: 'Julie Iwersen',
      text: 'Jeg to mit kørekort hos Lene i 2023. Trods min angst og panik for trafikken, sørgede Lene altid for ro og tryghed i bilen, ligegyldigt situationen. Utrolig dygtigt og sød kørelærer, der kan hjælpe alle sikkert og godt igang! Kæmpe anbefaling herfra',
      date: 'Februar 2026',
      rating: 5,
    },
    {
      name: 'Fie Schlitterlau',
      text: 'Jeg kan på det varmeste anbefale Lene. Allerede fra første køretime følte jeg mig i trygge hænder. Hun er utrolig behagelig, tålmodig og rolig, og hun tager sig altid god tid til at forklare tingene på en måde, der er let at forstå. Det gjorde, at jeg hele tiden følte mig tryg og mere sikker bag rattet – også når noget var svært eller nyt. Man kunne tydeligt mærke, at hun brænder for sit arbejde, og jeg har på intet tidspunkt fortrudt mit valg af køreskole. Jeg kunne ikke have ønsket mig en bedre kørelærer. Kæmpe anbefaling herfra ❤️',
      date: 'Februar 2026',
      rating: 5,
    },
    {
      name: 'Hannah Svan Sørensen',
      text: 'Jeg kan varmt anbefale at man tager kørekort hos Lene. Hun er både en faglig dygtig formidler og underviser i både den teoretiske og praktiske del. Og hun tager sig god tid til sine elever så man føler sig helt tryg bag rettet🥰',
      date: 'Februar 2026',
      rating: 5,
    },
    {
      name: 'Kristine Blomberg Schlaikjer- Petersen',
      text: 'Jeg startede på kørekort hos Lene i slutningen af april sidste år, og jeg var allerede færdig midt i juni. Det var en helt fantastisk oplevelse. Lene gjorde det virkelig trygt og var utrolig god til at guide mig – både i selve bilkørslen, men også i alle de tanker og bekymringer, man kan have undervejs. Jeg kunne ikke have gjort det uden Lenes hjælp :) Kæmpe anbefaling fra mig ♥️',
      date: 'Februar 2026',
      rating: 5,
    },
    {
      name: 'Emil Egholt',
      text: 'Uden tvivl den bedste køreskole. Lene er super rar og skaber altid en tryg samt afslappet stemning i bilen. Hun håndterer enhver situation roligt og på sin helt egen måde. Vil anbefale til alle der skal til at tage kørekort.',
      date: 'Februar 2026',
      rating: 5,
    },
    {
      name: 'Annabella Risager',
      text: 'Super god kørelærer! Hun er tålmodig og virkelig god til at forklare tingene, så man forstår det. Kan 100% anbefales🤗🌟',
      date: 'Februar 2026',
      rating: 5,
    },
    {
      name: 'Johanne Katrine Bygge Jensen',
      text: 'Jeg kan klart anbefale Lene Jauert’s køreskole, hun har støttet mig gennem hele mit kørekortforløb og hun har styr på tingene, Kan klart anbefales 🥰',
      date: 'Februar 2026',
      rating: 5,
    },
    {
      name: 'Christopher Elholm',
      text: 'Utrolig god kørelære, hun har styr på sine ting, god faglig teoriundervisning og utrolig god til køretimerne. Stor anbefaling herfra!',
      date: 'Februar 2026',
      rating: 5,
    },
    {
      name: 'The-Holy-vikings',
      text: 'Kan helt klart anbefale Lenes køreskole hun er utrolig god kørelærer, især hvis du har lidt angst og nervøsitet. Hun er rigtig god til at få dig til at føle dig tryg og giver sig tid til at lytte. Jeg var selv meget nervøs og havde ventet i flere år, men hos Lene følte jeg mig meget mere tryg end jeg selv havde regnet med. Fem stjerner herfra!',
      date: 'Februar 2026',
      rating: 5,
    },
    {
      name: 'Gustav Hoffmann',
      text: 'Tålmodig, professionel, og god til at forklare😀',
      date: 'Februar 2026',
      rating: 5,
    },
    {
      name: 'Laura Tietje',
      text: 'Lene er meget tålmodig og rigtig god til at hjælpe, især når man er nervøs. Jeg følte mig tryg hele vejen igennem, kan anbefales🫰🏼',
      date: 'April 2026',
      rating: 5,
    },
    {
      name: 'Nanna Fangel',
      text: 'Hvis i søger efter en køreskole hvor der er fokus på den enkelte, tryghed og gode grin så skal i helt sikkert vælge Lene. Hun er den bedste kørelærer i kan finde, hun er så dejlig rolig, sjov og hjælper en med hendes mange redskaber så man blir klædt på til teori, køretimer og prøver. Jeg har haft den bedste tid hos Lene, og hendes dejlige køreskole',
      date: '18. maj 2023',
      rating: 5,
    },
    {
      name: 'Marie Kathrine Schmidt',
      text: 'Hvis I står og er i tvivl om hvilken køreskole, I skal vælge, så kan Lenes køreskole i Aabenraa varmt anbefales. Hvorfor skal I så lige vælge hende... det skal I fordi hun er mega sympatiske, kan give en den indre ro og booste ens selvtillid, og samtidig med er hun mega sød. Hun har formodet, at få mig på 58 år til at bestå køreprøven 1 gang.',
      date: '',
      rating: 5,
    },
    {
      name: 'Karina Nielsen',
      text: 'Jeg anbefaler klart Lenes køreskole hun er det mest jordnære og tålmodige menneske jeg nogensinde har mødt jeg kom fra en anden køreskole hvor alt bare havde været svært og træls og skiftede til Lene den 4. Januar 2020 og den 24. februar 2020 kl 13.00 fik jeg mit længe ventede kørekort. Så jeg kan varmt anbefale det skønne menneske.',
      date: '24. februar 2020',
      rating: 5,
    },
    {
      name: 'Katrine Risbjerg Schimann Hansen',
      text: 'Lene er en fantastisk kørelærer, der virkeligt har styr på sine ting og ved hvordan hun skal få en til at føle sig sikker i trafikken. En klar anbefaling fra mig!',
      date: '',
      rating: 5,
    },
    {
      name: 'Emil Egholt',
      text: 'Byens bedste køreskole',
      date: '',
      rating: 5,
    },
    {
      name: 'Linea Lehmann Broe Bendtsen',
      text: 'Lene var min kørelærer i 2014 og kunne ikke ha’ ønsket mig bedre. Kan klart anbefales!',
      date: '2014',
      rating: 5,
    },
    {
      name: 'Mette Aaskov Jepsen',
      text: 'Lene er en super god kørelærer, som tager ting helt rolig. Hun er god til at lære fra sig, man føler sig i gode hænder når man er sammen med hende.',
      date: '',
      rating: 5,
    },
    {
      name: 'Sofie Smidt Hansen',
      text: 'Lene er ikke kun dygtig og professionel, hun er også en empatisk og indsigtsfuld menneskekender, der præcist og kærligt ser sine elevers kompetencer, deres væsen og hvor de har brug for hjælp. Hun er fantastisk.',
      date: '',
      rating: 5,
    },
    {
      name: 'Susett Lehné',
      text: 'Kun gode ord herfra - Lene er rigtig dygtig, god til at lære fra sig og meget tålmodighed. Stor anbefaling fra mig.',
      date: '',
      rating: 5,
    },
  ],
  contact: {
    email: 'Kontakt@lenejauert.dk',
    phone: '+45 40 58 61 11',
    address: 'Aabenraa, Danmark',
    cvr: '35934574',
    facebook: 'https://www.facebook.com/p/Lenes-K%C3%B8reskole-100063452328401/',
    message: 'Send mig en mail med din besked, så vender jeg tilbage til dig så hurtigt som muligt.',
    cta_title: 'Skriv en besked til mig',
    cta_subtitle: 'Kunne du tænke dig at starte hos den fedeste køreskole?'
  },
  images: {
    logo: '/logo-christineholme.png',
    car: '/Kundebilleder/imgi_6_IMG_8181-e1711204467190.jpg'
  },
  gallery: [
    { src: '/Kundebilleder/imgi_19_Rectangle-54.png', alt: 'Elev ved bilen' },
    { src: '/Kundebilleder/imgi_17_Forside-faerdig-2.jpg', alt: 'Særlig køreundervisning' },
    { src: '/Kundebilleder/imgi_6_IMG_8181-e1711204467190.jpg', alt: 'Vores skolevogn' },
    { src: '/Kundebilleder/imgi_14_Forside-faerdig-6.jpg', alt: 'Teoriundervisning' },
    { src: '/Kundebilleder/imgi_16_Forside-faerdig-3.jpg', alt: 'Klar til kørsel' },
    { src: '/Kundebilleder/imgi_18_Rectangle-52.png', alt: 'Glade elever' },
    { src: '/Kundebilleder/imgi_20_Rectangle-53.png', alt: 'Kørekort i hus' },
  ]
};
